// extracted by mini-css-extract-plugin
module.exports = {"list":"tags_list__2kTwd","item":"tags_item__jrukZ","upperCase":"tags_upperCase__OUDIn"};